import styled from '../../../theme'
import { IWithSize } from '../../../containers/BookingCalendar/Calendar/Calendar'

const SearchInput = styled.input<IWithSize>`
  margin-left: ${({ size }) => (size ? 15 * size : 15)}px;
  border: none;
  outline: none;
`

export default SearchInput
